import { httpRequest } from "../../http";
import { TeamMember } from "@models/teamMember.model";
import { TeamMemberSerializer } from "@models/serializers/teamMemberSerializer";

export class CommandGetTeamMembers {
  async run(engagementId: number = 0, roleCode?: string) {
    let url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/team-members/?start=0`;
    if (roleCode) {
      url += `&role_code=${roleCode}`;
    }
    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): TeamMember[] {
    const serializer = new TeamMemberSerializer();
    return serializer.deserializeList(data);
  }
}
